import React from "react";
import PropTypes from "prop-types";
import { RCL as useTranslation } from "../../components/RCL";
import { CardsContainerGrid } from "../../components/CardsContainer";
import { CardConnector } from "../CardConnector";

const CityTilesConnector = ({ cities, basePath }) => {
	const translations = {
		loadAll: useTranslation({ searchKey: "load-all" }),
		loadMore: useTranslation({ searchKey: "load-more" }),
		exploreMoreLabel: useTranslation({ searchKey: "explore-more" }),
	};

	const parsedCities = cities?.map(city => ({
		id: city.contentful_id,
		sys: {
			contentType: {
				sys: {
					id: "card",
				},
			},
		},
		variant: "Primary Default",
		theme: "Dark",
		heading: city?.destinationName,
		image: city?.image || city?.imageCarousel?.images,
		link: {
			variant: "Primary",
			linkText: translations.exploreMoreLabel,
			url: `${basePath}/${city?.slug}`,
			target: "_self",
		},
	}));

	return (
		<CardsContainerGrid
			numberToShow={6}
			labels={{
				loadAll: translations.loadAll,
				loadMore: translations.loadMore,
			}}>
			{parsedCities.map(item => (
				<CardConnector key={item.id} data={item} />
			))}
		</CardsContainerGrid>
	);
};

CityTilesConnector.propTypes = {
	cities: PropTypes.arrayOf(
		PropTypes.shape({
			destinationName: PropTypes.string,
			slug: PropTypes.string,
			images: PropTypes.arrayOf(
				PropTypes.shape({
					title: PropTypes.string,
					cloudinaryAsset: PropTypes.arrayOf(
						PropTypes.shape({
							secure_url: PropTypes.string,
							width: PropTypes.number,
							height: PropTypes.number,
							raw_transformation: PropTypes.string,
							version: PropTypes.number,
							public_id: PropTypes.string,
							format: PropTypes.string,
						})
					),
				})
			),
		})
	),
	locale: PropTypes.string,
	basePath: PropTypes.string,
};

CityTilesConnector.defaultProps = {
	cities: [],
	locale: "en-CA",
};

export { CityTilesConnector };
